var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup6505(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 383.658,
    height: 298.238,
    viewBox: "0 0 383.658 298.238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#403883;}.b{fill:url(#a);}.c{fill:#d7cfe2;}.d{fill:#fff;}.e{opacity:0.15;}.f{fill:#39147b;}.aa,.g{fill:#e8e2ee;}.h{fill:url(#b);}.i{fill:#242827;}.j{fill:#f7f7f7;}.k{fill:url(#c);}.l{fill:url(#d);}.m{fill:url(#e);}.n{fill:#c7cbe5;}.o{fill:#d9e8fb;}.p{fill:url(#f);}.q{fill:url(#m);}.r{fill:#fafbfd;}.s{fill:#fba56c;}.t{clip-path:url(#n);}.u{clip-path:url(#o);}.v{fill:#fdbfba;}.w{fill:#482366;}.x{fill:#ffc5b7;}.y{fill:url(#s);}.z{fill:url(#u);}.aa{opacity:0.5;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.712,
    y1: 0.954,
    x2: 0.247,
    y2: 0.131,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2300a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a14fbb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f89c1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2cb14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.79,
    y1: -0.012,
    x2: 0.05,
    y2: 0.864,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00bacf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31edb3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.766,
    y1: 0.059,
    x2: 0.374,
    y2: 0.788,
    href: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    href: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    href: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 0.523,
    y1: 0.905,
    x2: 0.478,
    y2: 0.119,
    href: "#c"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 2.959
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 2.959,
    y2: 0.001
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d57e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a2be6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 0.251,
    y1: 1.061,
    x2: 0.545,
    y2: 0.031,
    href: "#c"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-663.393 -336.57)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(692.067 363.788)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1049.342,525.674c-.037.263-.073.526-.117.8a23.642,23.642,0,0,1-3.355,8.594c-3.951,6.494-11,13.114-20.131,19.572-1.578,1.118-3.222,2.234-4.92,3.335C973.2,589.01,881,615.016,861.829,602.693c-37.28-23.965,8.634-44.163-31.132-51.706-21.136-4.007-47.668,5.875-69.2,6.764-1.651.07-3.275.083-4.863.036-8.355-.253-15.764-2.257-21.543-7.516a30.314,30.314,0,0,1-6.687-9.084,58.144,58.144,0,0,1-5.046-17.714,61.242,61.242,0,0,1-.553-6.1q-.115-2.737.02-5.536c.01-.243.024-.486.037-.732.063-1.032.15-2.067.263-3.112,2.79-25.833,21.589-55.108,65.473-82.708,66.927-42.093,157.18-33.871,173.75-25.962,14.646,6.99,22.967,22.3,10.652,53.257-7.817,19.648-19.176,33.3,25.962,42.606,5.4,1.115,10.535,1.891,15.315,2.556,5.692.792,10.885,1.421,15.438,2.263,1.594.293,3.112.615,4.543.982.932.233,1.834.489,2.7.769C1046.563,504.851,1051.469,510.746,1049.342,525.674Z",
    transform: "translate(-722.755 -392.918)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(786.87 413.909)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 192.52,
    height: 138.338,
    rx: 12.535,
    transform: "translate(0 9.666)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 168.002,
    height: 75.374,
    rx: 7.299,
    transform: "translate(11.2 58.705)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 168.305,
    height: 4.238,
    transform: "translate(11.049 36.457)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 168.305,
    height: 4.238,
    transform: "translate(11.049 44.932)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1129.167,516.693V634.121a4.651,4.651,0,0,1-4.65,4.654H1024.284a4.654,4.654,0,0,1-4.653-4.654V516.693Z",
    transform: "translate(-971.034 -507.027)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1111.544,522.749V532.89H919.023V522.749a6.053,6.053,0,0,1,6.054-6.054H1105.49A6.052,6.052,0,0,1,1111.544,522.749Z",
    transform: "translate(-919.023 -507.028)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 109.537,
    height: 125.755,
    rx: 9.632,
    transform: "translate(41.607)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(74.425 21.668)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1117.268,582.431h-4.786V563.625a17.3,17.3,0,1,0-34.6,0v18.806H1073.1V563.625a22.084,22.084,0,1,1,44.167,0Z",
    transform: "translate(-1073.101 -541.541)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 63.276,
    height: 48.232,
    rx: 7.787,
    transform: "translate(64.87 56.363)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1118.936,650.3a4.867,4.867,0,1,0-7.3,4.211v8.29a1.438,1.438,0,0,0,1.438,1.438h1.991a1.438,1.438,0,0,0,1.438-1.438v-8.29A4.862,4.862,0,0,0,1118.936,650.3Z",
    transform: "translate(-1017.339 -573.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "j",
    cx: 2.119,
    cy: 2.119,
    r: 2.119,
    transform: "translate(4.389 15.57)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "j",
    cx: 2.119,
    cy: 2.119,
    r: 2.119,
    transform: "translate(11.351 15.57)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "j",
    cx: 2.119,
    cy: 2.119,
    r: 2.119,
    transform: "translate(18.314 15.57)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(663.393 436.453)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1376.324,572.952c-1.977,3.3-9.839,11.49-29.078,3.232-.5,1.078-1.005,2.19-1.5,3.338a133.9,133.9,0,0,0-4.757,12.752c7.09-2.31,11.437-1.944,13.031-.35,1.665,1.664-3.328,6.324-7.323,4.327a16.2,16.2,0,0,0-6.417-1.671c-1.075,3.6-2.06,7.43-2.912,11.473,3.428-2.406,10.728-6.584,17.318-4.144a26.756,26.756,0,0,1,3.445,1.535c5.582,3.012,5.528,6.318,3.545,7.452a18.272,18.272,0,0,1-7.016,1.937c-4.277.419-10.319-.043-18.024-3.089-.606,3.282-1.5,15.005-2.107,22.661-1.578,1.118-3.222,2.234-4.92,3.335,1.088-9.45,3.036-24.748,5.02-32.513-2.131-.1-8.142-.912-9.234-6.644-1.148-6.031,7.113,3.3,9.406,5.972,1.095-4.214,2.459-8.817,4.144-13.557-6.424-2.48-12.432-7.972-15.877-13.491-3.395-5.436-4.3-10.9-.669-13.541,7.323-5.325,15.312,7.989,15.977,14.646q.059.6.13,1.158a30.88,30.88,0,0,0,1.787,7.582c.845-2.193,1.764-4.4,2.756-6.6a104.819,104.819,0,0,1,6.78-12.745c-2.4-1.352-12.086-7.266-9.457-13.693,2.926-7.157,10.3.945,11.261,10.944a69.244,69.244,0,0,1,9.879-11.637c-3.378-2.32.163-7.962.163-7.962,6.657-1.664,7.989,3.994,7.989,3.994s-3.768,5.5-7.246,4.414c-1.055,1.218-2.49,2.969-4.158,5.259,3.921-2.666,11.943-7.11,15.4-1.684,4.653,7.313-17.692,5.069-17.754,5.063a114.522,114.522,0,0,0-7.017,12.089,78.178,78.178,0,0,0,14.453-3.505C1373.329,565.962,1378.321,569.623,1376.324,572.952Z",
    transform: "translate(-1002.873 -543.354)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M730.811,659.411c-1.651.07-3.275.083-4.863.036-3.126-6.42-6.794-13.887-8.232-16.2a41.293,41.293,0,0,1-13.311,8.681c-.819.31-1.6.566-2.34.775a18.329,18.329,0,0,1-7.24.762c-2.26-.333-3.518-3.392.579-8.235a26.134,26.134,0,0,1,2.314-2.387c.11-.1.219-.2.333-.3,5.242-4.677,13.564-3.455,17.634-2.466-2.27-3.455-4.583-6.654-6.9-9.62a16.214,16.214,0,0,0-5.366,3.9c-2.989,3.319-9.34.8-8.4-1.354.9-2.067,4.816-3.995,12.259-4.434a134.193,134.193,0,0,0-9.083-10.132c-.879-.889-1.754-1.741-2.616-2.563q-1.778,1.752-3.462,3.149c-13.024,10.828-21.985,6.627-24.788,4.463-3.075-2.366.236-7.6,10.748-8.148a81,81,0,0,0,14.06-1.85l.676-.167c-.213-.193-.426-.379-.639-.566a113.843,113.843,0,0,0-10.308-8.125c-.057.03-20.038,10.278-18.377,1.771,1.235-6.311,10.325-5.106,14.948-4.054-2.39-1.524-4.364-2.63-5.792-3.378-2.839,2.283-8.358-1.462-8.358-1.462s-.829-5.755,5.978-6.637c0,0,5.359,3.961,3.059,7.353a69.35,69.35,0,0,1,13.447,7.223c-2.76-9.656,1.148-19.891,6.484-14.3,4.8,5.023-2.057,14.066-3.8,16.2q1.518,1.119,2.982,2.3c2.8,2.24,5.463,4.627,7.985,7.093,1.727,1.684,3.388,3.4,4.976,5.135a30.9,30.9,0,0,0-1.105-7.709c-.093-.366-.193-.739-.3-1.128-1.811-6.437.762-21.752,9.526-19.469,4.347,1.132,5.5,6.55,4.32,12.852-1.192,6.394-4.776,13.7-9.852,18.357,3.3,3.8,6.251,7.583,8.81,11.107,1.159-3.332,5.442-15.028,6.574-9,1.079,5.735-4.221,8.684-6.168,9.56C720.965,641.674,726.474,651.426,730.811,659.411Z",
    transform: "translate(-663.393 -567.244)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(878.657 570.9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M1132.627,821.694l-23.277,19.665v5.706h46.7v-5.706Z",
    transform: "translate(-1109.203 -821.694)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 46.85,
    height: 30.077,
    transform: "translate(0 19.376)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "o",
    width: 34.125,
    height: 36.439,
    transform: "translate(6.652 4.627)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M1155.895,861.807v30.077h-46.85V861.865l20.533,16.426h5.206l20.845-16.484Z",
    transform: "translate(-1109.044 -842.431)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M1155.42,902.717h-46.376v-.174l23.425-19.781Z",
    transform: "translate(-1109.044 -853.264)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.454 18.357)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.248)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1205.147,882.158h-2.629v-10.33a9.5,9.5,0,0,0-19,0v10.33h-2.629v-10.33a12.13,12.13,0,0,1,24.261,0Z",
    transform: "translate(-1180.886 -859.698)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 34.757,
    height: 26.493,
    rx: 4.277,
    transform: "translate(0 19.058)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1206.063,919.437a2.674,2.674,0,1,0-4.011,2.313V926.3a.791.791,0,0,0,.79.79h1.094a.791.791,0,0,0,.79-.79v-4.553A2.671,2.671,0,0,0,1206.063,919.437Z",
    transform: "translate(-1185.889 -889.199)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(998.389 538.688)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.738 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1375.012,755.006v36.157h25.31v-25.31l-10.245-10.847Z",
    transform: "translate(-1375.012 -755.006)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.725)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M1381.629,777.706v25.913h-24.707v-36.76h14.463l9.961,10.546Z",
    transform: "translate(-1356.922 -766.858)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.162 5.725)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1396.5,777.4H1386.24V766.858h.3Z",
    transform: "translate(-1386.24 -766.858)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.239 19.176)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 15.098,
    height: 1.678
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.28 4.473)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 15.098,
    height: 1.678
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.28 8.947)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 15.098,
    height: 1.678
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.28 13.42)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 15.098,
    height: 1.678
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.086 14.912)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1426.99,804.584H1424.8v-8.6a7.914,7.914,0,1,0-15.827,0v8.6h-2.189v-8.6a10.1,10.1,0,1,1,20.205,0Z",
    transform: "translate(-1406.785 -785.878)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 28.948,
    height: 22.065,
    rx: 3.562,
    transform: "translate(19.714 30.784)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1427.753,835.632a2.227,2.227,0,1,0-3.34,1.926v3.792a.657.657,0,0,0,.658.658h.91a.657.657,0,0,0,.658-.658v-3.792A2.223,2.223,0,0,0,1427.753,835.632Z",
    transform: "translate(-1391.237 -795.536)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(796.523 336.57)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M939.109,404.1a2.911,2.911,0,0,1,2.911-2.911h30.359a2.911,2.911,0,0,1,2.911,2.911v20.342a2.911,2.911,0,0,1-2.911,2.911H947.06l-8.053,10.527Z",
    transform: "translate(-939.007 -369.974)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M1014.119,375.321a2.911,2.911,0,0,0-2.911-2.911H980.85a2.911,2.911,0,0,0-2.911,2.911v20.343a2.911,2.911,0,0,0,2.911,2.911h25.318l8.054,10.527Z",
    transform: "translate(-959.134 -355.098)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 21.054,
    height: 2.453,
    transform: "translate(25.857 23.955)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 21.054,
    height: 2.453,
    transform: "translate(25.857 28.861)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 21.054,
    height: 2.453,
    transform: "translate(25.857 33.767)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.815)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.972)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1052.162,353.571h-1.99v-7.819a7.192,7.192,0,0,0-14.384,0v7.819h-1.99v-7.819a9.182,9.182,0,1,1,18.364,0Z",
    transform: "translate(-1033.798 -336.57)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 26.309,
    height: 20.053,
    rx: 3.237,
    transform: "translate(0 14.425)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1052.855,381.789a2.024,2.024,0,1,0-3.035,1.75v3.446a.6.6,0,0,0,.6.6h.828a.6.6,0,0,0,.6-.6v-3.446A2.021,2.021,0,0,0,1052.855,381.789Z",
    transform: "translate(-1037.585 -358.9)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(950.2 355.876)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "q",
    cx: 24.765,
    cy: 24.765,
    r: 24.765,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "r",
    cx: 22.033,
    cy: 22.033,
    r: 22.033,
    transform: "translate(2.733 2.733)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M1,0H14.98a1,1,0,0,1,1,1V1a1,1,0,0,1-1,1H1A1,1,0,0,1,0,1V1A1,1,0,0,1,1,0Z",
    transform: "matrix(0.896, -0.445, 0.445, 0.896, 22.745, 24.274)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1297.609,405.988a4.348,4.348,0,0,0-1.49.261l-6.937-11.255a1,1,0,1,0-1.7,1.048l6.967,11.3a4.354,4.354,0,1,0,3.16-1.359Z",
    transform: "translate(-1272.758 -385.834)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.253 4.032)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.427)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 2.959
  }), /*#__PURE__*/React.createElement("g", {
    className: "t"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,390.126Z",
    transform: "translate(-1308.252 -387.594)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,390.056Z",
    transform: "translate(-1308.252 -387.558)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,389.985Z",
    transform: "translate(-1308.252 -387.522)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,389.914Z",
    transform: "translate(-1308.252 -387.485)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,389.844Z",
    transform: "translate(-1308.252 -387.449)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,389.773Z",
    transform: "translate(-1308.252 -387.412)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,389.7Z",
    transform: "translate(-1308.252 -387.376)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,389.632Z",
    transform: "translate(-1308.252 -387.339)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,389.562Z",
    transform: "translate(-1308.252 -387.303)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,389.491Z",
    transform: "translate(-1308.252 -387.266)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,389.42Z",
    transform: "translate(-1308.252 -387.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,389.35Z",
    transform: "translate(-1308.252 -387.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,389.279Z",
    transform: "translate(-1308.252 -387.157)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,389.209Z",
    transform: "translate(-1308.252 -387.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,389.138Z",
    transform: "translate(-1308.252 -387.084)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,389.067Z",
    transform: "translate(-1308.252 -387.047)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,389Z",
    transform: "translate(-1308.252 -387.011)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,388.926Z",
    transform: "translate(-1308.252 -386.974)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,388.856Z",
    transform: "translate(-1308.252 -386.938)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,388.785Z",
    transform: "translate(-1308.252 -386.901)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,388.714Z",
    transform: "translate(-1308.252 -386.864)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,388.644Z",
    transform: "translate(-1308.252 -386.828)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,388.573Z",
    transform: "translate(-1308.252 -386.792)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,388.5Z",
    transform: "translate(-1308.252 -386.755)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,388.432Z",
    transform: "translate(-1308.252 -386.719)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,388.361Z",
    transform: "translate(-1308.252 -386.682)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,388.291Z",
    transform: "translate(-1308.252 -386.646)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,388.22Z",
    transform: "translate(-1308.252 -386.609)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,388.15Z",
    transform: "translate(-1308.252 -386.573)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,388.079Z",
    transform: "translate(-1308.252 -386.536)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,388.009Z",
    transform: "translate(-1308.252 -386.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,387.938Z",
    transform: "translate(-1308.252 -386.463)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,387.867Z",
    transform: "translate(-1308.252 -386.427)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,387.8Z",
    transform: "translate(-1308.252 -386.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,387.726Z",
    transform: "translate(-1308.252 -386.354)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,387.656Z",
    transform: "translate(-1308.252 -386.318)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,387.585Z",
    transform: "translate(-1308.252 -386.281)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,387.514Z",
    transform: "translate(-1308.252 -386.244)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,387.444Z",
    transform: "translate(-1308.252 -386.208)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,387.373Z",
    transform: "translate(-1308.252 -386.171)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,387.3Z",
    transform: "translate(-1308.252 -386.135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,387.232Z",
    transform: "translate(-1308.252 -386.098)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,387.161Z",
    transform: "translate(-1308.252 -386.062)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,387.091Z",
    transform: "translate(-1308.252 -386.025)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,387.02Z",
    transform: "translate(-1308.252 -385.989)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,386.95Z",
    transform: "translate(-1308.252 -385.953)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,386.879Z",
    transform: "translate(-1308.252 -385.916)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,386.808Z",
    transform: "translate(-1308.252 -385.879)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,386.738Z",
    transform: "translate(-1308.252 -385.843)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,386.667Z",
    transform: "translate(-1308.252 -385.806)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,386.6Z",
    transform: "translate(-1308.252 -385.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,386.526Z",
    transform: "translate(-1308.252 -385.733)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,386.456Z",
    transform: "translate(-1308.252 -385.697)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,386.385Z",
    transform: "translate(-1308.252 -385.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,386.314Z",
    transform: "translate(-1308.252 -385.624)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,386.244Z",
    transform: "translate(-1308.252 -385.588)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,386.173Z",
    transform: "translate(-1308.252 -385.551)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,386.1Z",
    transform: "translate(-1308.252 -385.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,386.1Z",
    transform: "translate(-1308.252 -385.515)"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.854,
    height: 2.959
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.071 24.281)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.426)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 2.959,
    y2: 0.001
  }), /*#__PURE__*/React.createElement("g", {
    className: "u"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1266.472,427.69Z",
    transform: "translate(-1266.045 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1266.542,427.69Z",
    transform: "translate(-1266.081 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1266.613,427.69Z",
    transform: "translate(-1266.118 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1266.684,427.69Z",
    transform: "translate(-1266.154 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1266.754,427.69Z",
    transform: "translate(-1266.19 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1266.825,427.69Z",
    transform: "translate(-1266.227 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1266.9,427.69Z",
    transform: "translate(-1266.263 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1266.966,427.69Z",
    transform: "translate(-1266.3 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1267.037,427.69Z",
    transform: "translate(-1266.337 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1267.107,427.69Z",
    transform: "translate(-1266.373 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1267.178,427.69Z",
    transform: "translate(-1266.41 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1267.248,427.69Z",
    transform: "translate(-1266.446 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1267.319,427.69Z",
    transform: "translate(-1266.482 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1267.389,427.69Z",
    transform: "translate(-1266.519 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1267.46,427.69Z",
    transform: "translate(-1266.555 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1267.531,427.69Z",
    transform: "translate(-1266.592 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1267.6,427.69Z",
    transform: "translate(-1266.628 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1267.672,427.69Z",
    transform: "translate(-1266.665 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1267.742,427.69Z",
    transform: "translate(-1266.701 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1267.813,427.69Z",
    transform: "translate(-1266.738 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1267.884,427.689Z",
    transform: "translate(-1266.775 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1267.954,427.689Z",
    transform: "translate(-1266.811 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1268.025,427.689Z",
    transform: "translate(-1266.847 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1268.095,427.689Z",
    transform: "translate(-1266.884 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1268.166,427.689Z",
    transform: "translate(-1266.92 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1268.237,427.689Z",
    transform: "translate(-1266.957 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1268.307,427.689Z",
    transform: "translate(-1266.993 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1268.378,427.689Z",
    transform: "translate(-1267.03 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1268.448,427.689Z",
    transform: "translate(-1267.066 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1268.519,427.689Z",
    transform: "translate(-1267.103 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1268.59,427.689Z",
    transform: "translate(-1267.14 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1268.66,427.689Z",
    transform: "translate(-1267.176 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1268.731,427.689Z",
    transform: "translate(-1267.212 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1268.8,427.689Z",
    transform: "translate(-1267.249 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1268.872,427.689Z",
    transform: "translate(-1267.285 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1268.942,427.689Z",
    transform: "translate(-1267.322 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1269.013,427.689Z",
    transform: "translate(-1267.358 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1269.084,427.689Z",
    transform: "translate(-1267.395 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1269.154,427.689Z",
    transform: "translate(-1267.431 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1269.225,427.689Z",
    transform: "translate(-1267.468 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1269.3,427.689Z",
    transform: "translate(-1267.504 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1269.366,427.689Z",
    transform: "translate(-1267.541 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1269.437,427.689Z",
    transform: "translate(-1267.577 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1269.507,427.689Z",
    transform: "translate(-1267.614 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1269.578,427.689Z",
    transform: "translate(-1267.65 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1269.648,427.689Z",
    transform: "translate(-1267.686 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1269.719,427.689Z",
    transform: "translate(-1267.723 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1269.79,427.689Z",
    transform: "translate(-1267.76 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1269.86,427.689Z",
    transform: "translate(-1267.796 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1269.931,427.689Z",
    transform: "translate(-1267.833 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1270,427.689Z",
    transform: "translate(-1267.869 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1270.072,427.689Z",
    transform: "translate(-1267.906 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1270.142,427.689Z",
    transform: "translate(-1267.942 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1270.213,427.688Z",
    transform: "translate(-1267.979 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1270.284,427.688Z",
    transform: "translate(-1268.015 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1270.354,427.688Z",
    transform: "translate(-1268.052 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1270.425,427.688Z",
    transform: "translate(-1268.088 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1270.495,427.688Z",
    transform: "translate(-1268.124 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1270.495,427.688Z",
    transform: "translate(-1268.124 -427.688)"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.959,
    height: 0.854
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.488 24.281)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.426)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 2.959,
    y2: 0.001
  }), /*#__PURE__*/React.createElement("g", {
    className: "u"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1346.005,427.69Z",
    transform: "translate(-1345.578 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1346.076,427.69Z",
    transform: "translate(-1345.615 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1346.146,427.69Z",
    transform: "translate(-1345.651 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1346.217,427.69Z",
    transform: "translate(-1345.687 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1346.287,427.69Z",
    transform: "translate(-1345.724 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1346.358,427.69Z",
    transform: "translate(-1345.76 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1346.429,427.69Z",
    transform: "translate(-1345.797 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1346.5,427.69Z",
    transform: "translate(-1345.833 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1346.57,427.69Z",
    transform: "translate(-1345.87 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1346.64,427.69Z",
    transform: "translate(-1345.906 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1346.711,427.69Z",
    transform: "translate(-1345.943 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1346.782,427.69Z",
    transform: "translate(-1345.979 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1346.852,427.69Z",
    transform: "translate(-1346.016 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1346.923,427.69Z",
    transform: "translate(-1346.052 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1346.993,427.69Z",
    transform: "translate(-1346.089 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1347.064,427.69Z",
    transform: "translate(-1346.125 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1347.135,427.69Z",
    transform: "translate(-1346.162 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1347.2,427.69Z",
    transform: "translate(-1346.198 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1347.276,427.69Z",
    transform: "translate(-1346.235 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1347.346,427.69Z",
    transform: "translate(-1346.271 -427.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1347.417,427.689Z",
    transform: "translate(-1346.308 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1347.488,427.689Z",
    transform: "translate(-1346.344 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1347.558,427.689Z",
    transform: "translate(-1346.381 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1347.629,427.689Z",
    transform: "translate(-1346.417 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1347.7,427.689Z",
    transform: "translate(-1346.453 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1347.77,427.689Z",
    transform: "translate(-1346.49 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1347.84,427.689Z",
    transform: "translate(-1346.526 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1347.911,427.689Z",
    transform: "translate(-1346.563 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1347.982,427.689Z",
    transform: "translate(-1346.6 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1348.052,427.689Z",
    transform: "translate(-1346.636 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1348.123,427.689Z",
    transform: "translate(-1346.673 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1348.193,427.689Z",
    transform: "translate(-1346.709 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1348.264,427.689Z",
    transform: "translate(-1346.746 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1348.335,427.689Z",
    transform: "translate(-1346.782 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1348.405,427.689Z",
    transform: "translate(-1346.818 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1348.476,427.689Z",
    transform: "translate(-1346.855 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1348.546,427.689Z",
    transform: "translate(-1346.891 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1348.617,427.689Z",
    transform: "translate(-1346.928 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1348.688,427.689Z",
    transform: "translate(-1346.965 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1348.758,427.689Z",
    transform: "translate(-1347.001 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1348.829,427.689Z",
    transform: "translate(-1347.038 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1348.9,427.689Z",
    transform: "translate(-1347.074 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1348.97,427.689Z",
    transform: "translate(-1347.111 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1349.041,427.689Z",
    transform: "translate(-1347.147 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1349.111,427.689Z",
    transform: "translate(-1347.183 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1349.182,427.689Z",
    transform: "translate(-1347.22 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1349.252,427.689Z",
    transform: "translate(-1347.256 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1349.323,427.689Z",
    transform: "translate(-1347.293 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1349.393,427.689Z",
    transform: "translate(-1347.329 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1349.464,427.689Z",
    transform: "translate(-1347.366 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1349.535,427.689Z",
    transform: "translate(-1347.403 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1349.6,427.689Z",
    transform: "translate(-1347.439 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1349.676,427.689Z",
    transform: "translate(-1347.476 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1349.746,427.688Z",
    transform: "translate(-1347.512 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1349.817,427.688Z",
    transform: "translate(-1347.548 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1349.888,427.688Z",
    transform: "translate(-1347.585 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1349.958,427.688Z",
    transform: "translate(-1347.621 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1350.029,427.688Z",
    transform: "translate(-1347.658 -427.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1350.029,427.688Z",
    transform: "translate(-1347.658 -427.688)"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.959,
    height: 0.854
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.253 42.528)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.427)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 2.959
  }), /*#__PURE__*/React.createElement("g", {
    className: "t"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,469.823Z",
    transform: "translate(-1308.252 -467.291)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,469.753Z",
    transform: "translate(-1308.252 -467.255)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,469.682Z",
    transform: "translate(-1308.252 -467.218)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,469.611Z",
    transform: "translate(-1308.252 -467.182)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,469.541Z",
    transform: "translate(-1308.252 -467.146)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,469.47Z",
    transform: "translate(-1308.252 -467.109)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,469.4Z",
    transform: "translate(-1308.252 -467.073)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,469.329Z",
    transform: "translate(-1308.252 -467.036)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,469.258Z",
    transform: "translate(-1308.252 -466.999)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,469.188Z",
    transform: "translate(-1308.252 -466.963)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,469.117Z",
    transform: "translate(-1308.252 -466.926)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,469.047Z",
    transform: "translate(-1308.252 -466.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,468.976Z",
    transform: "translate(-1308.252 -466.853)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,468.9Z",
    transform: "translate(-1308.252 -466.817)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,468.835Z",
    transform: "translate(-1308.252 -466.781)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,468.764Z",
    transform: "translate(-1308.252 -466.744)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,468.694Z",
    transform: "translate(-1308.252 -466.708)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,468.623Z",
    transform: "translate(-1308.252 -466.671)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,468.552Z",
    transform: "translate(-1308.252 -466.634)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,468.482Z",
    transform: "translate(-1308.252 -466.598)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,468.411Z",
    transform: "translate(-1308.252 -466.561)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,468.341Z",
    transform: "translate(-1308.252 -466.525)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,468.27Z",
    transform: "translate(-1308.252 -466.488)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,468.2Z",
    transform: "translate(-1308.252 -466.452)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,468.129Z",
    transform: "translate(-1308.252 -466.416)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,468.058Z",
    transform: "translate(-1308.252 -466.379)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,467.988Z",
    transform: "translate(-1308.252 -466.343)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,467.917Z",
    transform: "translate(-1308.252 -466.306)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,467.847Z",
    transform: "translate(-1308.252 -466.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,467.776Z",
    transform: "translate(-1308.252 -466.233)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,467.7Z",
    transform: "translate(-1308.252 -466.196)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,467.635Z",
    transform: "translate(-1308.252 -466.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,467.564Z",
    transform: "translate(-1308.252 -466.124)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,467.494Z",
    transform: "translate(-1308.252 -466.087)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,467.423Z",
    transform: "translate(-1308.252 -466.051)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,467.352Z",
    transform: "translate(-1308.252 -466.014)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,467.282Z",
    transform: "translate(-1308.252 -465.978)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,467.211Z",
    transform: "translate(-1308.252 -465.941)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,467.141Z",
    transform: "translate(-1308.252 -465.905)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,467.07Z",
    transform: "translate(-1308.252 -465.868)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,467Z",
    transform: "translate(-1308.252 -465.831)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,466.929Z",
    transform: "translate(-1308.252 -465.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,466.858Z",
    transform: "translate(-1308.252 -465.759)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,466.788Z",
    transform: "translate(-1308.252 -465.722)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,466.717Z",
    transform: "translate(-1308.252 -465.686)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,466.647Z",
    transform: "translate(-1308.252 -465.649)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,466.576Z",
    transform: "translate(-1308.252 -465.613)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,466.505Z",
    transform: "translate(-1308.252 -465.576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,466.435Z",
    transform: "translate(-1308.252 -465.54)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,466.364Z",
    transform: "translate(-1308.252 -465.503)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,466.294Z",
    transform: "translate(-1308.252 -465.467)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,466.223Z",
    transform: "translate(-1308.252 -465.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,466.152Z",
    transform: "translate(-1308.252 -465.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,466.082Z",
    transform: "translate(-1308.252 -465.357)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,466.011Z",
    transform: "translate(-1308.252 -465.321)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,465.941Z",
    transform: "translate(-1308.252 -465.284)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,465.87Z",
    transform: "translate(-1308.252 -465.248)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,465.8Z",
    transform: "translate(-1308.252 -465.211)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1308.252,465.8Z",
    transform: "translate(-1308.252 -465.211)"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.854,
    height: 2.959
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.274 19.971)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.024)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1343.106,439.384h-2.517V429.5a9.1,9.1,0,1,0-18.191,0v9.889h-2.517V429.5a11.612,11.612,0,0,1,23.224,0Z",
    transform: "translate(-1319.882 -417.884)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 33.272,
    height: 25.361,
    rx: 4.094,
    transform: "translate(0 18.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1343.984,475.07a2.559,2.559,0,1,0-3.839,2.214v4.359a.756.756,0,0,0,.756.756h1.047a.756.756,0,0,0,.756-.756v-4.359A2.556,2.556,0,0,0,1343.984,475.07Z",
    transform: "translate(-1324.672 -446.124)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(687.838 389.043)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M829.092,492.358l1.874,10.115-13.35.979-.51-20.524s-1.984-.014-3.362-2.773c-1.664-3.329,1.351-3.731,1.351-3.731l.972-6.254s13.5-8.628,15.128-2.217c5.056,19.838-2.736,20.963-2.736,20.963l0,.043.027.15Z",
    transform: "translate(-765.306 -455.738)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M815.665,461.117s12.243-10.38,16.676,1.607c.84,2.274.929,5.357-.444,7.175l-.764-3.977a65.626,65.626,0,0,1-12.291.863,17.558,17.558,0,0,0-1.418,3.819l-.006,2.964-.561.1s-1.43-3.3-3.909-.88C812.949,472.788,809.512,461.371,815.665,461.117Z",
    transform: "translate(-764.659 -451.273)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M805.73,451.844l-7.06.975-3.994,1.664a7.473,7.473,0,0,1,5.325,2.33l-4.66,1-7.033,2.244L779.7,462.8l-3.661-4.993,8.131-3.672,2.187-.988,2.33-2,7.193-3.129a5.558,5.558,0,0,1,3.548.127l6.448,2.416A.662.662,0,0,1,805.73,451.844Z",
    transform: "translate(-746.071 -446.542)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M1011.125,846.478l-6.757,5.948-1.708-2.174-1.135-1.445-3.319-4.221,7.413-6.527,2.443,3.731.7,1.068Z",
    transform: "translate(-860.926 -648.297)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1011.049,857.763l-3.2-5.659a8.83,8.83,0,0,0,6.881-6.061l15.712-4.709a.821.821,0,0,1,.779,1.4l-17.56,15.465A1.7,1.7,0,0,1,1011.049,857.763Z",
    transform: "translate(-865.91 -649.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M920.1,910.88l-8.391,3.262-.855-2.63-.826-2.54-1.4-4.314,9.207-3.575.9,3.868.4,1.721Z",
    transform: "translate(-814.615 -680.879)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M918.729,904.952c-2.959,1.378-6.441,3-8.7,4.021l-1.4-4.314,9.207-3.575Z",
    transform: "translate(-814.615 -680.879)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1008.063,841.791l-6.537,7.017-3.319-4.221,7.413-6.527Z",
    transform: "translate(-860.926 -648.297)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M914.57,926.025l-1.058-6.416a8.83,8.83,0,0,0,8.547-3.32l16.373.99a.821.821,0,0,1,.248,1.585l-21.811,8.473A1.7,1.7,0,0,1,914.57,926.025Z",
    transform: "translate(-817.142 -688.739)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M909.529,745.314l-12.982,9.32-36.591-46.926-7.013-8.994L806.011,663.1l34.451-7.822.729.616L868.318,678.8a16.74,16.74,0,0,1,3.522,4.128Z",
    transform: "translate(-761.567 -553.804)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M859.957,707.708l-7.013-8.994L806.011,663.1l34.451-7.822.729.616.769,2.546Z",
    transform: "translate(-761.567 -553.804)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M865.851,458.375l-4.367,4.387-7.812-3.861-6.91-3.416L842.3,453.8a7.479,7.479,0,0,1,5.612-1.508l-3.7-2.244-6.837-2.017a.663.663,0,0,1,.053-1.285l6.734-1.425a5.577,5.577,0,0,1,3.529.406l6.644,4.171,2,2.323,2.43,1.575Z",
    transform: "translate(-777.54 -445.202)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M788.308,466.846,779.7,469.6l-3.661-4.993,8.132-3.671Z",
    transform: "translate(-746.071 -453.334)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M883.792,467.575l-4.367,4.387-7.812-3.861,5.1-5.1Z",
    transform: "translate(-795.481 -454.402)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M864.739,778.834l-15.644,4.327-17.305-60.08-.336-1.165s-1.691-2.483-4.094-6.048c-4.9-7.263-12.755-19.029-15.278-23.476-3.978-7.017-11.584-25.064-11.584-25.064l31.455-5.159,2.739,7.376,15.218,40.941a14.393,14.393,0,0,1,.562,1.931l.543,2.53Z",
    transform: "translate(-758.717 -557.367)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M827.359,715.868c-4.9-7.263-12.755-19.029-15.278-23.476-3.978-7.017-11.584-25.064-11.584-25.064l31.455-5.159,2.739,7.376C828.638,676.3,818.855,691.849,827.359,715.868Z",
    transform: "translate(-758.717 -557.367)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M823.491,487.33,794.23,505.617l.093.905,5.562,53.583s-2.916,4.43-14.146,6.158c-8.654,1.331-32.769.206-32.769.206v-.363c0-3.378-.043-29.544-.766-38.764-.42-5.346-4.008-21.725-4.008-21.725l-31.854-22.7a5.576,5.576,0,0,1,.992-9.646l33.419-13.038,4.464,10.269-22.628,9.363L765.1,491.7c12.649,10.651,13.637.419,13.637.419l29.538-11.473L791.89,468.943l4.683-7.8,26.825,16.1A5.917,5.917,0,0,1,823.491,487.33Z",
    transform: "translate(-714.001 -452.974)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M841.592,609.644s-2.916,4.43-14.147,6.158c-8.654,1.331-32.769.206-32.769.206v-.363c9.8-3.728,37.047-17.764,41.354-59.584Z",
    transform: "translate(-755.707 -502.513)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M837.469,514.726c-4.983-.932-7.922-5.708-8.022-5.875a12.446,12.446,0,0,0,7.419,2.626Z",
    transform: "translate(-773.683 -478.107)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(769.229 372.763)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M898.224,461.562h42.5s-5.741-7.087-13.049-5.758a7.592,7.592,0,0,0-8.858-6.2s-7.185-11.418-17.937-5.315c-2.626,1.49-5.315,5.315-6.2,9.522,0,0-9.08-.664-12.18,7.751Z",
    transform: "translate(-882.501 -427.523)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1104.234,437.217h57.323s-7.744-9.558-17.6-7.766c0,0-1.493-9.557-11.947-8.363,0,0-9.69-15.4-24.193-7.168-3.542,2.01-7.168,7.168-8.363,12.843,0,0-12.246-.9-16.427,10.453Z",
    transform: "translate(-986.167 -411.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup6505);
export default __webpack_public_path__ + "static/media/Group 6505.10c8ff35d13ae4303074210a45f7a23c.svg";
export { ForwardRef as ReactComponent };